import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import { StaffAccountingApiResponse } from "../model/accounting-api.model";
import {
  StaffDueDateExtensionRequest, StaffDueDateExtensionResponse,
  StaffExpenseReportDetailResponse, StaffExpenseReportRequest, StaffExpenseReportResponse,
  StaffSupportDocumentRequest, StaffSupportDocumentResponse,
} from "../model/expense-report.model";

@Injectable({ providedIn: "root" })
export class StaffExpenseReportsService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.url = `${basePath.replace(/\/$/, "")}/api/v1/expense-reports`;
  }

  getByRequirement(requirementId: number): Observable<StaffAccountingApiResponse<StaffExpenseReportDetailResponse>> {
    return this.http.get<StaffAccountingApiResponse<StaffExpenseReportDetailResponse>>(`${this.url}/requirement/${requirementId}`);
  }

  render(requirementId: number, request: StaffExpenseReportRequest): Observable<StaffAccountingApiResponse<StaffExpenseReportResponse>> {
    return this.http.put<StaffAccountingApiResponse<StaffExpenseReportResponse>>(`${this.url}/requirement/${requirementId}`, request);
  }

  addDocument(requirementId: number, request: StaffSupportDocumentRequest): Observable<StaffAccountingApiResponse<StaffSupportDocumentResponse>> {
    return this.http.post<StaffAccountingApiResponse<StaffSupportDocumentResponse>>(`${this.url}/requirement/${requirementId}/documents`, request);
  }

  addDocumentToReport(expenseReportId: number, request: StaffSupportDocumentRequest): Observable<StaffAccountingApiResponse<StaffSupportDocumentResponse>> {
    return this.http.post<StaffAccountingApiResponse<StaffSupportDocumentResponse>>(`${this.url}/${expenseReportId}/documents`, request);
  }

  requestExtension(expenseReportId: number, request: StaffDueDateExtensionRequest): Observable<StaffAccountingApiResponse<StaffDueDateExtensionResponse>> {
    return this.http.post<StaffAccountingApiResponse<StaffDueDateExtensionResponse>>(`${this.url}/${expenseReportId}/extensions`, request);
  }
}
